import React, { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

import { FinishButton } from '../components/buttons/Buttons';
import checkMark from '../img/checkmark.png';
import validarAgente from '../img/exito.webp';
import useTrackEvent from '../utils/trackEvent';
import { useTenant } from '../context/TenantContext';

const Exito = () => {
  const hasPushedPageView = useRef(false);
  const { pushPageView } = useTrackEvent();
  const { isMeliTenant } = useTenant();
  const navigate = useNavigate();

  const finishHandleClick = () => {
    navigate('/');
  };

  useEffect(() => {
    if (!hasPushedPageView.current) {
      pushPageView(
        'vpv',
        'Crédito Automotríz',
        '4',
        '/atencion-normal/solicitud-enviada',
        'Solicitud enviada - Atención Normal'
      );

      hasPushedPageView.current = true;
    }
  }, []);

  return (
    <>
      <div className="image-container">
        <img src={validarAgente} alt="Validar con agente" />
        <div className="checkmark-wrapper">
          <img src={checkMark} alt="CheckMark" width={110} />
        </div>
      </div>
      <div className="content-container">
        <h2>
          <strong style={{ color: '#1D364C' }}>¡Gracias!</strong>
        </h2>
        {isMobile ? (
          <>
            <p>
              Hemos recibido tus datos y nuestro equipo ya está trabajando en una oferta de
              financiamiento a tu medida.
              <br />
              Uno de nuestros ejecutivos te contactará pronto para continuar con el proceso.
            </p>
          </>
        ) : (
          <>
            <p>Hemos recibido tus datos y nuestro equipo ya está trabajando en una oferta de</p>
            <p>financiamiento a tu medida.</p>
            <p style={{ marginTop: 5 }}>Uno de nuestros ejecutivos te contactará pronto para</p>
            <p>continuar con el proceso.</p>
          </>
        )}
        {!isMeliTenant ? <FinishButton onClick={finishHandleClick} /> : <></>}
      </div>
    </>
  );
};

export default Exito;
